import { theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useManagePermittedRoles } from 'library/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { devicesActions } from 'reduxStore/devices/slice';
import { selectDevicesByDeviceID } from 'reduxStore/devices/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { Typography } from 'zui/Antd';
import { SelectFontSizeLG } from 'zui/Antd/Select';
import RemoveSiteDeviceModal from 'zComponents/molecules/RemoveSiteDeviceModal';

const { Text } = Typography;

const EditSiteSelect = ({ deviceID }) => {
	const {
		token: { fontSizeLG, colorPrimary }
	} = theme.useToken();
	const dispatch = useDispatch();
	const isGlobalAdmin = useManagePermittedRoles('manageSiteAssignment');
	const canEdit = useManagePermittedRoles('manageDeviceSites');

	const sites = useSelector(selectSites);
	const device = useSelector((state) => selectDevicesByDeviceID(state, deviceID));

	const siteIDs = device?.sites?.map((s) => s.siteID) || [];

	const [editableSiteIDs, setEditableSiteIDs] = useState(siteIDs);
	const [removeModalVisible, setRemoveModalVisible] = useState(false);
	const [siteIDsToRemove, setSiteIDsToRemove] = useState([]);

	useEffect(() => {
		setEditableSiteIDs(siteIDs);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [device?.sites]);

	const handleSelectChange = (newValue) => {
		const removed = editableSiteIDs.filter((id) => !newValue.includes(id));

		if (removed.length > 0) {
			setSiteIDsToRemove(removed);
			setRemoveModalVisible(true);
			return;
		}

		setEditableSiteIDs(newValue);
		dispatch(devicesActions.updateDeviceSites({ deviceID, siteIDs: newValue }));
	};

	const options = sites.map((site) => ({
		label: site.name,
		value: site.siteID
	}));

	const showSelect = isGlobalAdmin || (canEdit && sites.length > 1);

	if (!showSelect) {
		const siteNames = sites
			.filter((s) => siteIDs.includes(s.siteID))
			.map((s) => s.name)
			.join(', ');
		return <Text style={{ fontSize: fontSizeLG }}>{siteNames || '-'}</Text>;
	}

	return (
		<>
			<SelectFontSizeLG
				mode='multiple'
				value={editableSiteIDs}
				onChange={handleSelectChange}
				placeholder='Select Sites'
				options={options}
				showSearch={false}
				virtual={false}
				maxTagCount={1}
				maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
				$tagColor={colorPrimary}
				style={{ minWidth: 228, maxWidth: 400 }}
				allowClear
			/>
			<RemoveSiteDeviceModal
				deviceID={deviceID}
				siteIDs={siteIDsToRemove}
				visible={removeModalVisible}
				setVisible={setRemoveModalVisible}
			/>
		</>
	);
};

export default EditSiteSelect;
